import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { getPiiNsp } from '../../shared/pii/pii.utils';
import { InceptionService } from '@proximus/ng-common';
import { PlcCodes } from '@dch/products-business-logic';

@Component({
  selector: 'mprd-nsp-activation-container',
  templateUrl: './nsp-activation-container.component.html',
})
export class NspActivationContainerComponent implements OnInit {
  nspAsFromPriceKey: string;

  constructor(
    private router: Router,
    private inceptionService: InceptionService,
  ) {}

  ngOnInit(): void {
    this.getAsFromPrice();
    this.inceptionService.init();
    this.scrollToTop();
  }

  getAsFromPrice() {
    const { packId, productId, plcList } = getPiiNsp();

    if (packId) {
      this.nspAsFromPriceKey = 'nsp.activation.pack.price.asfrom.value';
    } else if (
      plcList &&
      plcList.some((plc) => plc === PlcCodes.MI || plc === PlcCodes.MV)
    ) {
      this.nspAsFromPriceKey =
        'nsp.activation.standalone.mobile.price.asfrom.value';
    } else if (productId && plcList && plcList.includes(PlcCodes.FI)) {
      this.nspAsFromPriceKey =
        'nsp.activation.standalone.internet.price.asfrom.value';
    }
  }

  goToNextNspStep() {
    const { packId, productId, plcList } = getPiiNsp();
    if (packId || productId) {
      this.router.navigate(['/nspActivationInternet']);
    } else if (plcList) {
      this.router.navigate(['/nspActivationMobile']);
    } else {
      // fallback in case of invalid PII info
      this.router.navigate(['/overview']);
    }
  }

  private scrollToTop(): void {
    setTimeout(() => {
      this.inceptionService.scrollToElement('#nspActivation');
    });
  }
}
